export default "<div class=\"error invalid-feedback\"  *ngIf=\"isError\" >\r\n    <strong>{{message}}</strong>\r\n</div>\r\n"